import axios from 'axios';
import { AppSettings } from '../../configs';
import { authHeader } from '../../helpers/auth-header';

import {
  START_LOADING,
  STOP_LOADING,
  SET_M_YEAR_END_PO,
  SET_M_YEAR_END_PO_FAIL,
  ERROR_M_YEAR_END_PO_FAIL,
  UPLOAD_FILE,
  GET_EXPORT_REPORT,
  UPDATE_LOCK_PO_MODAL,
  UPLOAD_SUCCESS
}
  from '../actions/actionTypes';

export function addMYearEndPOAction(model) {

  return function (dispatch) {
    dispatch({
      type: START_LOADING
    })
    try {
      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/Master/AddYearEndPOContract`,
        data: model
      })

      promise.then(response => {
        let isSuccess = response.data.isSuccess === true
        let returnMessage = response.data.returnMessage

        if (isSuccess) {
          dispatch({
            type: STOP_LOADING
          })
        } else {
          dispatch({
            type: SET_M_YEAR_END_PO_FAIL,
            payload: returnMessage
          });
          dispatch({
            type: ERROR_M_YEAR_END_PO_FAIL,
            payload: returnMessage
          });
        }

      }
      );

      return promise
    } catch (error) {
      dispatch({
        type: STOP_LOADING
      })
    }
  }
}
export function getMYearEndPOAction(po_contract_no, header_text, vendor, status,department_owner) {
  return function (dispatch) {

    try {
      let promise = axios({
        headers: authHeader(),
        method: "get",
        url: `${AppSettings.apiUrl}/api/Master/GetYearEndPOContract`,
        params: {
          po_contract_no: po_contract_no,
          header_text: header_text,
          vendor: vendor,
          status: status,
          department_owner: department_owner

        }
      })

      promise.then(response => {
        
        console.log("getMYearEndPOAction => " ,response.data)
        if (response.data.success) {
          dispatch({
            type: SET_M_YEAR_END_PO,
            payload: response.data.response,
          });
        } else {
          dispatch({
            type: SET_M_YEAR_END_PO_FAIL,
            payload: response.data.response,
          });
        }

      }
      );

      return promise
    } catch (error) {

    }
  }
}

export function uploadYearEndPOContract(data) {
  return function (dispatch) {

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      'Pragma': 'no-cache'
    };

    dispatch({
      type: START_LOADING
    })

    try {
      return axios.post(`${AppSettings.apiUrl}/api/Master/UploadYearEndPOContract`, data, config)
        .then(response => {
          console.log('UploadYearEndPOContract==>response', response)
          dispatch({
            type: STOP_LOADING
          })

          dispatch({
            type: UPLOAD_FILE,
            payload: response.data,
          });
        });
    } catch (error) {
      dispatch({
        type: STOP_LOADING
      })

    } finally {
    }

  }
}

export function downloadYearEndPOContract() {
  return function (dispatch) {

    dispatch({
      type: START_LOADING
    })

    try {
      let promise = axios({
        headers: authHeader(),
        method: "get",
        url: `${AppSettings.apiUrl}/api/Master/DownloadYearEndPOContractTemplate`,
      })

      promise.then(response => {
        dispatch({
          type: GET_EXPORT_REPORT,
          payload: response.data,
        });
        dispatch({
          type: STOP_LOADING
        });
      }
      );

      return promise
    } catch (error) {
      dispatch({
        type: STOP_LOADING
      })

    } finally {
    }
  }
}

export function updateLockPOModalAction(data) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_LOCK_PO_MODAL,
      data: data
    });
  }
}

export function clearErrorMsgAction() {
  return function (dispatch) {
    dispatch({
      type: SET_M_YEAR_END_PO_FAIL,
      data: ""
    });
  }
}

export function saveAll(model){
  return function (dispatch) {
    dispatch({
      type: START_LOADING
    })
    try {
      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/Master/SaveUploadYearEndPOContract`,
        data: model
      })

      promise.then(response => {
        let isSuccess = response.data.isSuccess === true
        let returnMessage = response.data.returnMessage

        if (isSuccess) {
          dispatch({
            type: UPLOAD_SUCCESS,
            payload:response.data
          })
        } else {
          dispatch({
            type: SET_M_YEAR_END_PO_FAIL,
            payload: returnMessage
          });
          dispatch({
            type: ERROR_M_YEAR_END_PO_FAIL,
            payload: returnMessage
          });
        }

      }
      ).finally(() => {
        dispatch({
            type: STOP_LOADING,
        })
      });

      return promise
    } catch (error) {
      dispatch({
        type: STOP_LOADING
      })
    }
  }
}



export function getTransactionHistory(transection_no) {

    try {
      let promise = axios({
        headers: authHeader(),
        method: "get",
        url: `${AppSettings.apiUrl}/api/RRS/TransactionHistory/Item`,
        params: {
            transection_no: transection_no
          }
      })
      return promise
    } catch (error) {
    } finally {
    }
}

export function getYearEndPOListAction(po_contract_no) {
  return  function (dispatch) {
    try {
        let promise=  axios({
            headers: authHeader(),
            method: "get",
            url: `${AppSettings.apiUrl}/api/Master/GetYearEndPOList`,
            params: {
              po_contract_no: po_contract_no
            }
        })

        return promise
    } catch (error) {

    }
}

}
